__turbopack_context__.v({
  "deleteButton": "product-gift-for-basket-item-module-scss-module__w4UV7W__deleteButton",
  "root": "product-gift-for-basket-item-module-scss-module__w4UV7W__root",
  "root__giftImage": "product-gift-for-basket-item-module-scss-module__w4UV7W__root__giftImage",
  "root__image": "product-gift-for-basket-item-module-scss-module__w4UV7W__root__image",
  "root__info": "product-gift-for-basket-item-module-scss-module__w4UV7W__root__info",
  "root__main": "product-gift-for-basket-item-module-scss-module__w4UV7W__root__main",
  "root__quantity": "product-gift-for-basket-item-module-scss-module__w4UV7W__root__quantity",
});
